import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { AutomationActionButton } from './ActionButton';


const AutomationVariantPicker = ({
  resource,
}) => {
  return (
    <FDStack direction={'row'} key={resource.id()} spacing={1}>
      <FDTitleText value={resource.attr('description')} />
      <FDStack flexGrow={1} />
      <AutomationActionButton automationSuggestionVariantResource={resource} />
    </FDStack>
  );
};

AutomationVariantPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AutomationVariantPicker;
